'use strict';

module.exports = {
  manualEntry: 'MANUAL_ENTRY',
  feed: 'FEED',
  assortment: 'assortment',
  tool: 'tool',
  competitorSources: {
    manual: 'manual',
    feed: 'feed',
    storeGroup: 'storeGroup',
  },
  competitorToggles: ['feed', 'manual', 'storeGroup'],
  scenarioResults: {
    strategicEngine: 'strategic-engine',
    crossElasticity: 'cross-elasticity',
    override: 'price-override',
    clone: 'clone',
  },
};
